import View from './View';

export { default as View, getPlayerControlsStyles } from './View';

export default View;
